function AdminInstructorsController($scope, $state) {}
AdminInstructorsController.$inject = ["$scope", "$state"];
export default AdminInstructorsController;

